import Reveal from "@/components/Reveal";

const GROUPS = [
  {
    id: "amazon-sellers",
    index: "01",
    title: "Amazon Sellers",
    desc: "Overstock and shelf-pull merchandise in case and pallet quantities, sourced to your categories — inventory you can list, not browse.",
  },
  {
    id: "resellers-distributors",
    index: "02",
    title: "Resellers & Distributors",
    desc: "Flexible lots across product categories with pricing by quote, so you can buy at wholesale depth without retail overhead.",
  },
  {
    id: "overseas-buyers",
    index: "03",
    title: "Overseas Buyers",
    desc: "Merchandise sourced, coordinated, and prepared for export to your destination, with the commercial documents your forwarder needs.",
  },
];

const Serve = () => (
  <section id="serve" className="py-24 md:py-32" data-testid="serve-section">
    <div className="max-w-[1240px] mx-auto px-5 md:px-8">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-accent" data-testid="serve-eyebrow">
          Who We Serve
        </p>
        <h2
          className="mt-5 font-display font-extrabold text-ink tracking-[-0.02em] leading-[1.02] text-[clamp(2rem,4.2vw,3.4rem)] max-w-2xl"
          data-testid="serve-heading"
        >
          Built for buyers who move product.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-px bg-slate-200 border border-slate-200 rounded-2xl overflow-hidden md:grid-cols-3">
        {GROUPS.map((g, i) => (
          <Reveal key={g.id} delay={0.06 + i * 0.07} className="h-full">
            <div
              data-testid={`serve-card-${g.id}`}
              className="group h-full bg-white hover:bg-surface transition-colors duration-300 p-8 md:p-10"
            >
              <span className="font-display font-extrabold text-[44px] leading-none text-slate-200 group-hover:text-accent transition-colors duration-300">
                {g.index}
              </span>
              <h3 className="mt-8 font-display font-bold text-[21px] tracking-tight text-ink">
                {g.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-slate-600">{g.desc}</p>
              <p className="mt-6 font-mono text-[10px] tracking-[0.22em] uppercase text-slate-400">
                Call for availability & pricing
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Serve;
